import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiFolder, FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { formatFileName } from '../utilities/formatFileName';
import { countFiles } from '../utilities/countFiles';
import { findFolderPath } from '../utilities/folderUtils';
import { getOrganizationFromPath } from '../utilities/organizationUtils';

const FolderDetail = ({ item, onFileSelect, onFolderSelect, folderIdFromUrl, allFolders }) => {
  const [expandedFolders, setExpandedFolders] = useState(new Set());
  const navigate = useNavigate();
  const location = useLocation();
  const currentOrg = getOrganizationFromPath(location.pathname);

  useEffect(() => {
    if (!folderIdFromUrl || !allFolders) {
      setExpandedFolders(new Set());
      return;
    }

    // Find the path to the target folder and expand all folders in that path
    const folderPath = findFolderPath(allFolders, folderIdFromUrl);
    if (folderPath.length > 0) {
      setExpandedFolders(new Set(folderPath));
    }
  }, [folderIdFromUrl, allFolders]);

  const toggleFolder = async (folder) => {
    // Toggle expansion state
    setExpandedFolders(prev => {
      const newSet = new Set(prev);
      if (newSet.has(folder.Id)) {
        newSet.delete(folder.Id);
      } else {
        newSet.add(folder.Id);
      }
      return newSet;
    });
    
    // Call onFolderSelect to trigger navigation and content loading
    if (onFolderSelect) {
      onFolderSelect(folder.Id, folder.FileUrl, folder.Name);
    }
  };

  const renderFolder = (folder) => {
    const isExpanded = expandedFolders.has(folder.Id);
    const filteredChildren = folder.Children?.filter(
      child => !['logo.png', 'logo.jpg'].includes(child.Name.toLowerCase())
    ) || [];

    return (
      <div key={folder.Id} className="ml-1">
        <div
          onClick={() => toggleFolder(folder)}
          className="flex items-center gap-2 cursor-pointer py-1 hover:bg-gray-100 px-1 rounded"
        >
          {isExpanded ? <FiChevronDown className="text-gray-500 w-4 h-4 flex-shrink-0" /> : <FiChevronRight className="text-gray-500 w-4 h-4 flex-shrink-0" />}
          <FiFolder className="text-yellow-500 w-4 h-4 flex-shrink-0" />
            <span className={`text-gray-800 text-sm ${isExpanded ? 'font-bold' : ''}`}>
              {folder.Name}
            </span>
        </div>
        {isExpanded && (
          <div className="ml-2 border-l border-gray-200 pl-2">
            {filteredChildren.map(child => (
              <FolderDetail 
                key={child.Id}
                item={child}
                onFileSelect={onFileSelect}
                onFolderSelect={onFolderSelect}
                folderIdFromUrl={folderIdFromUrl}
                allFolders={allFolders}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  return <>{renderFolder(item)}</>;
};

export default FolderDetail;